import { AddTask, AssignmentInd, Cancel, CheckCircle, DirectionsBike, HourglassEmpty, StoreOutlined, Error } from "@mui/icons-material";
import { alpha, Chip, SvgIconProps } from "@mui/material"
import { blue, green, grey, orange, red, teal, yellow } from "@mui/material/colors";
import { chipOpacity, chipPadding } from "./common";
import MopedIcon from '@mui/icons-material/Moped';
import { IconWithText } from "./components";
import { DriverType } from "../../../interfaces/delivery-company/drivers";
import { PickupTaskState } from "../../../enums/tasks";
import { DriverWithIcon } from "./driver-with-icon";


const icon = <StoreOutlined />
export const showPickupTaskChip = (pickupID: string, onClick?: () => void, driver?: DriverType): JSX.Element => {
    return <div style={onClick ? { cursor: "pointer" } : {}} onClick={onClick && ((e) => { e.stopPropagation(); onClick() })}>
        <Chip style={{ background: alpha(yellow[400], chipOpacity), padding: chipPadding, fontWeight: "bold", }} icon={icon} label={`Pickup #${pickupID}`} />
        {driver && <>
            <div style={{ width: "100%", marginTop: 0 }}>
                <IconWithText centered> <MopedIcon color='primary' /><p>{driver.name}</p></IconWithText>
            </div>
        </>}
    </div >
}

export const getPickupTaskStateColor = (state: PickupTaskState): string => {
    switch (state) {
        case PickupTaskState.CREATED:
            return alpha(blue[500], chipOpacity);
        case PickupTaskState.ASSIGNED:
            return alpha(teal[500], chipOpacity);
        case PickupTaskState.IN_PROGRESS:
            return alpha(orange[500], chipOpacity);
        case PickupTaskState.PICKED_UP:
            return alpha(green[400], chipOpacity);
        case PickupTaskState.COMPLETED:
            return alpha(green[500], chipOpacity);
        case PickupTaskState.CANCELLED:
            return alpha(red[700], chipOpacity);
        case PickupTaskState.FAILED:
            return alpha(red[500], chipOpacity);
        default:
            return alpha(grey[700], chipOpacity);
    }
};

export const getPickupTaskStateIcon = (state: PickupTaskState): JSX.Element => {
    const iconProps: SvgIconProps = { fontSize: 'small', color: 'inherit' };

    switch (state) {
        case PickupTaskState.CREATED:
            return <AddTask {...iconProps} />;
        case PickupTaskState.ASSIGNED:
            return <AssignmentInd {...iconProps} />;
        case PickupTaskState.IN_PROGRESS:
            return <HourglassEmpty {...iconProps} />;
        case PickupTaskState.PICKED_UP:
            return <DirectionsBike {...iconProps} />;
        case PickupTaskState.COMPLETED:
            return <CheckCircle {...iconProps} />;
        case PickupTaskState.CANCELLED:
            return <Cancel {...iconProps} />;
        case PickupTaskState.FAILED:
            return <Error {...iconProps} />;
    }
};

export const showPickupTaskState = (state: PickupTaskState, driver?: DriverType | null): JSX.Element => {
    return (
        <div>
            <Chip
                icon={getPickupTaskStateIcon(state)}
                label={<b>{state.toString().replaceAll("_", " ")}</b>}
                variant="filled"
                style={{
                    margin: 4,
                    padding: chipPadding,
                    backgroundColor: getPickupTaskStateColor(state),
                }}
            />
            <DriverWithIcon driver={driver} centered />
        </div>
    );
};

